import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import "./cource.css";
import cardImage from "./course1.png";
function Index() {
 const navigate = useNavigate();

    
  return (
    <div className="pattern-bnner">
       <div className="container-fluid">
          <Navbar />
       </div>
       <div className="container-main">
        <div className="cource-heading-top">
          <h3 className="text-center ">Courses</h3>
          <h1 className="text-center ">Learn at Your Own Pace, Advance Your Practice</h1>
          <p className="text-center">Comprehensive courses designed for solo advocates, law firms, and enterprises — gain practical knowledge and skills that fit your schedule and needs.</p>     
        </div>
           <div className="pt-3">
            <h4>Explore Our Courses</h4>
              <div onClick={() => navigate("/course/ai-Powered-drafting")} className="col-md-4 pt-2">
               <div className="card ai-card shadow-sm">
                    <img
                    src={cardImage}
                    className="card-img-top-course ai-card-img"
                    alt="AI Powered Drafting"
                    />

        <div className="card-body pt-3 p-0">
          <h5 className="card-title fw-bold">
            AI Powered Drafting
          </h5>

          <p className="card-text text-muted">
            Learn to draft legal documents efficiently using AI.
            Gain hands-on experience with Jurisbot AI and enhance
            your skills for academic and professional success.
          </p>

          <div className="d-flex flex-wrap gap-3 mt-3">
            <span className="  text-dark ">
              Beginner Friendly
            </span>
            <span className=" text-dark ">
              1 – 8 Weeks
            </span>
            <span className="text-dark ">
              Certification
            </span>
          </div>
        </div>
      </div>
    </div>
        </div>
       </div>
    </div>
  )
}

export default Index